import { Pipe, PipeTransform } from '@angular/core'
import { truncate } from 'lodash'

type TruncatePosition = 'start' | 'middle' | 'end'

interface TruncateOptions {
  length?: number
  omission?: string
  position?: TruncatePosition
}

const DEFAULT_LENGTH = 30
const DEFAULT_OMISSION = '...'
const DEFAULT_POSITION: TruncatePosition = 'end'

@Pipe({
  name: 'truncate',
})
export class TruncatePipe implements PipeTransform {
  transform(
    value: string,
    lengthOrOptions?: number | TruncateOptions,
    position: TruncatePosition = DEFAULT_POSITION,
    omission = DEFAULT_OMISSION
  ): string {
    return truncateStr(value, lengthOrOptions, position, omission)
  }
}

export function truncateStr(
  value: string,
  lengthOrOptions?: number | TruncateOptions,
  position: TruncatePosition = DEFAULT_POSITION,
  omission = DEFAULT_OMISSION
): string {
  const safeValue = value ?? ''
  if (!safeValue) {
    return ''
  }

  const options: TruncateOptions =
    typeof lengthOrOptions === 'number' ? { length: lengthOrOptions, position, omission } : lengthOrOptions ?? {}

  const length = options.length ?? DEFAULT_LENGTH
  const omissionValue = options.omission ?? omission ?? DEFAULT_OMISSION
  const truncatePosition = options.position ?? position ?? DEFAULT_POSITION

  if (safeValue.length <= length) {
    return safeValue
  }

  if (length <= omissionValue.length) {
    return safeValue.slice(0, length)
  }

  if (truncatePosition === 'start') {
    const keep = length - omissionValue.length
    return `${omissionValue}${safeValue.slice(safeValue.length - keep)}`
  }

  if (truncatePosition === 'middle') {
    const keep = length - omissionValue.length
    const head = Math.ceil(keep / 2)
    const tail = Math.floor(keep / 2)
    return `${safeValue.slice(0, head)}${omissionValue}${safeValue.slice(safeValue.length - tail)}`
  }

  return truncate(safeValue, {
    length,
    omission: omissionValue,
  })
}
